/**
 * Shape discriminant for `GET /drugs/{id}/sbas`.
 *
 * The endpoint returns one of two shapes. The cycle envelope carries
 * `available_cycles` / `unclassified_count` / `unmatched_labels`; the legacy
 * flat shape carries none of them. The backend omits the property entirely
 * for the legacy shape (capability flag off, non-US drug, no `?cycle` param,
 * or a degenerate drug with zero labels AND zero reviews).
 *
 * Discriminate on PROPERTY PRESENCE, never on array length. `available_cycles:
 * []` is a valid, ACTIVE envelope — an all-blank-app US drug resolves no
 * submissions but still reaches its labels through `unmatched_labels`, and an
 * unclassified-docs-only drug likewise has no cycles but real content. Gating
 * on `.length` would strand both in classic view.
 */
export function hasCycleEnvelope(data: unknown): boolean {
  if (data === null || typeof data !== 'object') return false;
  return Object.prototype.hasOwnProperty.call(data, 'available_cycles');
}
